/**
 * The Cancellation policy screen's URL view state and sort columns (DNKADM-0430 P1-F).
 *
 * URL params on `/cancellation-policy` (all optional; a default is never written):
 * - `q`: search on the "Applies to" label.
 * - `sort` + `dir`: the column sort. The default is today's fixed order: Cancel at least
 *   (`minHoursBeforeStart`) descending, the "largest qualifying" evaluation order. Bands
 *   with the same threshold then order by their "Applies to" label, so the order is
 *   deterministic.
 */
import type { CancellationBand } from '@/api/policies';
import type { SortState, SortValue } from '@/components/list/listSort';

export const POLICIES_URL_DEFAULTS = { q: '', sort: '', dir: '' };

export type BandSortKey = 'appliesTo' | 'hours' | 'refund';
export const BAND_SORT_KEYS: readonly BandSortKey[] = ['appliesTo', 'hours', 'refund'];
export const BAND_DEFAULT_SORT: SortState<BandSortKey> = { key: 'hours', dir: 'desc' };

/**
 * What a band sorts by in each column. `label` is the band's resolved "Applies to"
 * label (the bucket name, or "All buckets").
 */
export function bandSortValue(band: CancellationBand, key: BandSortKey, label: string): SortValue {
  switch (key) {
    case 'appliesTo':
      return label;
    case 'hours':
      return band.minHoursBeforeStart;
    case 'refund':
      return band.refundPercent;
  }
}
